import { Component, Input } from '@angular/core';

@Component({
    selector: 'ui-user-profile-picture',
    templateUrl: './user-profile-picture.component.html',
    styleUrls: ['./user-profile-picture.component.less']
})
export class UserProfilePictureComponent {
    @Input() userInitials: string;
    @Input() userPhoto: unknown;
}
